import { CartProduct } from '@shared/cart-js';
import { AXONCategory, AXONEventMap, AXONEventType } from './types';

const useAppLovin = () => {
  const track = <E extends AXONEventType>(event: E, data: AXONEventMap[E]) => {
    if (typeof window !== 'undefined' && window.axon?.ts) {
      window.axon('track', event, data);
    }
  };

  return { axon: { track } };
};

const formatCartProductsAsAxonItems = (
  cartProducts: Record<string, CartProduct>,
) => {
  return Object.values(cartProducts).map((product) => ({
    item_id: product.sku,
    quantity: product.qty,
    price: product.total,
    item_name: product.name ?? '',
    image_url: product.primaryImage?.url ?? '',
    item_category_id:
      productAxonCategoryMap[product.sku] ??
      AXONCategory.SECURITY_SYSTEM_SENSORS,
  }));
};

export * from './types';
export { formatCartProductsAsAxonItems };
export default useAppLovin;

export const productAxonCategoryMap: Record<string, AXONCategory> = {
  'CPA-HUB-345-1': AXONCategory.HOME_ALARM_SYSTEMS,
  'CPA-PANEL-345-1': AXONCategory.HOME_ALARM_SYSTEMS,
  'CP-DS-345-1': AXONCategory.SECURITY_SYSTEM_SENSORS,
  'CP-WS-345-1': AXONCategory.SECURITY_SYSTEM_SENSORS,
  'CP-PIR-345-1': AXONCategory.MOTION_SENSORS,
  '2G-GB-345-1': AXONCategory.SECURITY_SYSTEM_SENSORS,
  'secondary-siren': AXONCategory.SECURITY_SYSTEM_SENSORS,
  '2GIG-SMKT8-345': AXONCategory.SMOKE_DETECTORS,
  '2GIG-CO8-345': AXONCategory.CARBON_MONOXIDE_DETECTORS,
  'CP-FS-345-1': AXONCategory.WATER_AND_FLOOD_DETECTORS,
  'CP-KEY-345-1': AXONCategory.SECURITY_SYSTEM_SENSORS,
  'CP-MED-345-1': AXONCategory.SECURITY_SYSTEM_SENSORS,
  'indoor-camera-eufy': AXONCategory.SURVEILLANCE_CAMERAS,
  'doorbell-camera-eufy': AXONCategory.SURVEILLANCE_CAMERAS,
  'outdoor-camera-eufy': AXONCategory.SURVEILLANCE_CAMERAS,
  'window-sticker-sm': AXONCategory.SECURITY_SYSTEM_SENSORS,
  'CP-YS-23i-1': AXONCategory.SECURITY_SYSTEM_SENSORS,
};
